import React from 'react';

import { supporterOrganizations } from '../../constants';

import * as S from './styles';

function WithLoveFooter() {
  return (
    <S.Container>
      <S.Content>
        <S.SupportContainer>
          <S.SupportText>With generous support from:</S.SupportText>
          <S.LogosContainer>
            {supporterOrganizations.map((org) => (
              <S.LogoWrapper key={org.id}>
                <S.Logo alt={org.name} src={org.logoUrl} />
              </S.LogoWrapper>
            ))}
          </S.LogosContainer>
        </S.SupportContainer>

        <S.TextOrganization>Movement Commons</S.TextOrganization>
      </S.Content>
    </S.Container>
  );
}

export default WithLoveFooter;
